<template>
  <WebPanelPage class="colors-route" title="Colors">
    <div class="maxwidth">
      <h1 class="f-header mb4">Greys</h1>
      <div class="grid">
        <div class="bg-white w-100" v-for="color in greys" :key="color.variable">
          <RatioContainer :ratio="100">
            <div class="h-100 w-100" :style="{ background: `var(${color.variable})`}"></div>
          </RatioContainer>
          <!-- <div class="flex flex-column item-center h-100"> -->
          <pre class="f-instructions tc pa3">{{color.hex}}</pre>
          <!-- </div> -->
        </div>
      </div>
      <h1 class="f-header mb4 mv4">Colors</h1>
      <div class="grid-4 mb4" v-for="(colorGroup, i) in colors" :key="i">
        <div class="w-100" v-for="color in colorGroup.colors" :key="color.variable">
          <RatioContainer :ratio="100">
            <div class="h-100 w-100" :style="{ background: `var(${color.variable})`}"></div>
          </RatioContainer>
          <!-- <div class="flex flex-column item-center h-100"> -->
          <!-- </div> -->
        </div>
        <div style="grid-column: 3 / span 3" class="tl">
          <h3 class="f-title mb3">{{ colorGroup.name }}</h3>
          <div class="flex">
            <div class="mr5">
              <h3 class="f-label mb2">Normal</h3>
              <pre class="f-instructions mb4">{{colorGroup.colors[0].hex}}</pre>
            </div>
            <div>
              <h3 class="f-label mb2">Hover</h3>
              <pre class="f-instructions mb4">{{colorGroup.colors[1].hex}}</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </WebPanelPage>
</template>
<script>
import WebPanelPage from '@sbvr/web-panel/WebPanelPage';
import RatioContainer from '@sbvr/common/legacy-shared/components/utils/RatioContainer';

export default {
  name: 'ColorsRoute',
  components: {
    WebPanelPage,
    RatioContainer,
  },
  setup () {
    const greys = [
      {
        variable: '--colorDarkest',
        hex: '#182942',
      },
      {
        variable: '--colorDark',
        hex: '#283B57',
      },
      {
        variable: '--colorMedium',
        hex: '#879AB2',
      },
      {
        variable: '--colorLight',
        hex: '#D5D8DF',
      },
      {
        variable: '--colorLightest',
        hex: '#F7F8F8',
      },
    ];
    const colors = [
      {
        name: 'SBVR Red',
        colors: [
          {
            variable: '--colorSBRed',
            hex: `linear-gradient(
              135deg,
              #F24F36 0%,
              #F35437 37.81%,
              #F99941 100%
            )`,
          },
          {
            variable: '--colorSBRedHover',
            hex: `linear-gradient(
              135deg,
              #CE3018 0%,
              #E96F00 100%
            )`,
          },
        ],
      },
      {
        name: 'SBVR Red Flat',
        colors: [
          {
            variable: '--colorSBRedFlat',
            hex: '#EC4E36',
          },
          {
            variable: '--colorSBRedFlatHover',
            hex: '#CB3B25',
          },
        ],
      },
      {
        name: 'SBVR Error',
        colors: [
          {
            variable: '--colorError',
            hex: `linear-gradient(
              315deg,
              #FCD95A 0%,
              #FB8F1E 100%
            )`,
          },
          {
            variable: '--colorErrorHover',
            hex: `linear-gradient(
              315deg,
              #EEB529 0%,
              #D76825 100%
            )`,
          },
        ],
      },
      {
        name: 'SBVR Error Flat',
        colors: [
          {
            variable: '--colorErrorFlat',
            hex: '#F9B141',
          },
          {
            variable: '--colorErrorFlatHover',
            hex: '#DD911C',
          },
        ],
      },
      {
        name: 'SBVR Success',
        colors: [
          {
            variable: '--colorSuccess',
            hex: `linear-gradient(
              315deg,
              #00CE8A 0%,
              #0CA2A9 100%
            )`,
          },
          {
            variable: '--colorSuccessHover',
            hex: `linear-gradient(
              315deg,
              #00CE8A 0%,
              #0CA2A9 100%
            )`,
          },
        ],
      },
      {
        name: 'SBVR Success Flat',
        colors: [
          {
            variable: '--colorSuccessFlat',
            hex: '#07BEA5',
          },
          {
            variable: '--colorSuccessFlatHover',
            hex: '#00A38D',
          },
        ],
      },
      {
        name: 'SBVR Info',
        colors: [
          {
            variable: '--colorInfo',
            hex: `linear-gradient(
              135deg,
              #0174CC 0%,
              #50AFFF 100%
            )`,
          },
          {
            variable: '--colorInfoHover',
            hex: `linear-gradient(
              135deg,
              #0174CC 0%,
              #50AFFF 100%
            )`,
          },
        ],
      },
      {
        name: 'SBVR Info Flat',
        colors: [
          {
            variable: '--colorInfoFlat',
            hex: '#4CA7F4',
          },
          {
            variable: '--colorInfoFlatHover',
            hex: '#308BD7',
          },
        ],
      },

      // {
      //   variable: '--colorPlaceholderGradient',
      //   hex: 'linear-gradient(270deg, var(--colorCasper) 0%, #F1F1F1 100%)',
      // },
      // {
      //   variable: '--colorNearDark',
      //   hex: 'color-mod(#182942 b(78%))',
      // },
    ];
    return {
      colors,
      greys,
    };
  },
};
</script>

<style lang="postcss" scoped>
.colors-route {
  & .grid {
    display: grid;
    grid-gap: 3rem;
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  & .grid-4 {
    display: grid;
    grid-gap: 3rem;
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  & .maxwidth {
    max-width: 100rem;
  }
}
</style>
